import React, { useState } from 'react';
import { IFormMccCard } from '../../../../editCustomerState/editCustomerContext';
import { CardBrands } from 'types';
import { useTranslation } from 'react-i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { FormRow } from 'components/EntityForm/FormRow';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import { BaseMccField } from './BaseMccField';
import { CardBrandSelect } from './CardBrandSelect';
import { MccField } from './MccField';

interface IProps {
	mccCards: IFormMccCard[];
	mainMccCardBrand: Nullable<CardBrands>;
	reservedMccCardBrands: Nullable<CardBrands>[];
	changeBaseMcc: (value: Nullable<number>) => void;
	changeMainMccCardBrand: (value: CardBrands) => void;
	changeMainMccCardMcc: (value: Nullable<number>) => void;
	changeMccCardBrand: (id: string, value: CardBrands) => void;
	changeMccCardMcc: (id: string, value: Nullable<number>) => void;
	addMccCard: (value: IFormMccCard) => void;
	deleteMccCard: (id: string) => void;
}

export const Mcc: React.FC<IProps> = ({
	mccCards,
	mainMccCardBrand,
	reservedMccCardBrands,
	changeBaseMcc,
	changeMainMccCardBrand,
	changeMainMccCardMcc,
	changeMccCardBrand,
	changeMccCardMcc,
	addMccCard,
	deleteMccCard,
}) => {
	const { t } = useTranslation('form');
	const [nextCardId, setNextCardId] = useState<number>(1);

	const handleAddCard = () => {
		addMccCard({ id: String(nextCardId), brand: null, mcc: null });
		setNextCardId((prevId) => prevId + 1);
	};

	return (
		<div className="flex flex-col gap-4">
			<BaseMccField changeBaseMcc={changeBaseMcc} />
			<FormRow>
				<CardBrandSelect
					name="mainMccCardBrand"
					testId="MainCardBrandSelect"
					selectedBrand={mainMccCardBrand}
					reservedBrands={reservedMccCardBrands}
					onChange={changeMainMccCardBrand}
				/>
				<MccField
					name="mainMccCardMcc"
					brandFieldName="mainMccCardBrand"
					testId="MainMccField"
					onChange={changeMainMccCardMcc}
				/>
			</FormRow>
			{mccCards.map((el) => (
				<div key={el.id} className="flex items-start gap-8">
					<CardBrandSelect
						name={`cardBrand-${el.id}`}
						mccFieldName={`mcc-${el.id}`}
						testId="CardBrandSelect"
						selectedBrand={el.brand}
						reservedBrands={reservedMccCardBrands}
						onChange={(value) => changeMccCardBrand(el.id, value)}
					/>
					<MccField
						name={`mcc-${el.id}`}
						brandFieldName={`cardBrand-${el.id}`}
						testId="MccField"
						onChange={(value) => changeMccCardMcc(el.id, value)}
					/>
					<NewButton
						className="mt-7.5"
						variant="shadow"
						color="red"
						size="small"
						icon={true}
						iconLeft={<Icon name={IconName.delete} size="lg" />}
						ariaLabel={t('deleteButton')}
						testId="DeleteMccCardBtn"
						onClick={() => deleteMccCard(el.id)}
					/>
				</div>
			))}
			<div>
				<NewButton
					size="small"
					iconLeft={<Icon name={IconName.plus} size="lg" />}
					disabled={mccCards.length >= 9}
					testId="AddMccCardBtn"
					onClick={handleAddCard}>
					<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
				</NewButton>
			</div>
		</div>
	);
};
